import {
  MENU_PERMISSION_GROUPS,
  ROUTE_PERMISSION_CODES,
} from '@/constants/permissions';

const getPermissionName = (permission: any) => {
  if (typeof permission === 'string') {
    return permission;
  }

  return permission?.name;
};

export default (initialState: any = {}) => {
  const permissions = new Set(
    (initialState?.permissions || []).map(getPermissionName).filter(Boolean),
  );
  const hasPermission = (code: string) => permissions.has(code);
  const hasAnyPermission = (codes: readonly string[]) =>
    codes.some(hasPermission);

  return {
    canSeeAdmin: !!(initialState && initialState.name !== 'dontHaveAccess'),
    ...Object.entries(MENU_PERMISSION_GROUPS).reduce<Record<string, boolean>>(
      (accessMap, [accessKey, codes]) => {
        accessMap[accessKey] = hasAnyPermission(codes);
        return accessMap;
      },
      {},
    ),
    ...ROUTE_PERMISSION_CODES.reduce<Record<string, boolean>>(
      (accessMap, code) => {
        accessMap[code] = hasPermission(code);
        return accessMap;
      },
      {},
    ),
  };
};
